<template>
  <div :class="{'the-timeline__item_active': active}">
    <slot
      :toggleActive="toggleActive"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
    }
  },
  methods: {
    toggleActive() {
      this.active = !this.active
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TheTimelineItem.vue